import { useEffect } from 'react';

//assets/icons/person-lines-fill.svg
import { ReactComponent as PersonLinesFill } from 'assets/icons/person-lines-fill.svg';
//assets/icons/chevron-down.svg
import { CheckOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg';
import { OptionEntity } from 'domain/entities/OptionEntity';
import {
    changeImplementerClassification,
    setHeaderInfo,
} from 'presentation/redux/features/authen/authenSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { commonHelpers } from 'utilities/helpers';

export const BUYER_CLASSIFICATION = 110;
export const SELLER_CLASSIFICATION = 210;

const IMPLEMENTER_CLASSIFICATION_OPTIONS = [
    { label: '買いたい', value: BUYER_CLASSIFICATION },
    { label: '売りたい', value: SELLER_CLASSIFICATION },
];

interface props {
    implementerClassification?: number;
    grantPoint?: number;
    onChangeImplementerClassification?: (value: number) => void;
    title?: string | JSX.Element;
    disableSelect?: boolean;
    defalultData?: number | null;
}


export const HeaderRightComponent = (props: props) => {
    const userSlice = useAppSelector((state) => state.user);
    const dispatch = useAppDispatch();

    const defaultValue = (props.defalultData == SELLER_CLASSIFICATION ? SELLER_CLASSIFICATION : BUYER_CLASSIFICATION);
    if(props.defalultData == SELLER_CLASSIFICATION){
        dispatch(changeImplementerClassification(SELLER_CLASSIFICATION));
    }
    const DEFAULT_DATA = {
        implementerClassification: defaultValue,
        grantPoint: 0,
    };
    useEffect(() => {
        if (props && props.implementerClassification) {
            dispatch(setHeaderInfo(props));
            // Cookieと同期
            if (props.implementerClassification === SELLER_CLASSIFICATION) {
                commonHelpers.setCookie('selling', 'true');
            } else {
                commonHelpers.deleteCookie('selling');
            }
        } else if (!userSlice?.implementerClassification) {
            // Reduxの状態が存在しない場合、Cookieの値を優先的に確認
            const sellingCookie = commonHelpers.getCookie('selling');
            let initialClassification: number;
            
            if (sellingCookie === 'true') {
                // Cookieに「selling=true」がある場合は、売りたいを設定
                initialClassification = SELLER_CLASSIFICATION;
            } else {
                // Cookieがない場合は、デフォルト値を使用
                initialClassification = defaultValue;
            }
            
            dispatch(changeImplementerClassification(initialClassification));
            dispatch(setHeaderInfo({
                implementerClassification: initialClassification,
                grantPoint: 0,
            }));
            
            // Cookieと同期
            if (initialClassification === SELLER_CLASSIFICATION) {
                commonHelpers.setCookie('selling', 'true');
            } else {
                commonHelpers.deleteCookie('selling');
            }
        } else if (userSlice?.implementerClassification) {
            // Reduxの状態が復元されたときにCookieと同期
            if (userSlice.implementerClassification === SELLER_CLASSIFICATION) {
                commonHelpers.setCookie('selling', 'true');
            } else {
                commonHelpers.deleteCookie('selling');
            }
        }
    }, [props, userSlice?.implementerClassification]);

    const changeOption = (value: number) => {
        dispatch(changeImplementerClassification(value));
        // 売りたいを選択した場合はcookieに保存、買いたいの場合は削除
        if (value === SELLER_CLASSIFICATION) {
            commonHelpers.setCookie('selling', 'true');
        } else {
            commonHelpers.deleteCookie('selling');
        }
    };

    const { Option } = Select;

    return (
        <>
            <div className="flex space justify-between w-full pr-[20px]">
                <div className="flex flex-start items-center gap-8">{props.title}</div>
                <div className="flex flex-end gap-8">
                    {/* <div className="flex items-start gap-2.5 py-2 px-4 rounded-full bg-white/[.40] text-white text-xs font-bold leading-[100%]">
                        スコア：{commonHelpers.formatNumberMoney(userSlice?.user?.grantPoint || 0)}
                    </div> */}
                    <div className="flex items-center gap-1">
                        <PersonLinesFill />
                        <Select
                            size="small"
                            className="select-header"
                            disabled={props.disableSelect}
                            defaultValue={defaultValue}
                            value={userSlice?.implementerClassification || BUYER_CLASSIFICATION}
                            suffixIcon={<ChevronDown fill="white" />}
                            onChange={changeOption}
                            optionLabelProp="label"
                        >
                            {IMPLEMENTER_CLASSIFICATION_OPTIONS.map(
                                (item: OptionEntity, index: number) => {
                                    return (
                                        <Option key={index} value={item.value} label={item.label}>
                                            {item.label}
                                            {userSlice?.implementerClassification == item.value && (
                                                <CheckOutlined style={{ color: '#1F8DDD' }} />
                                            )}
                                        </Option>
                                    );
                                },
                            )}
                        </Select>
                    </div>
                </div>
            </div>
        </>
    );
};
